import { pipe } from 'ramda';

import { buildCmsUrl, CMSApiBase, getResponseCMS } from './base';
import { request } from '@/api/base';
import { getResponseCamelization } from '@/helpers/api';

export interface CMSConfigDateRange {
  start: string;
  end: string;
}

export interface CMSConfigApi extends CMSApiBase {
  bonanzaPromo?: CMSConfigDateRange;
  scratchGame?: CMSConfigDateRange;
  fortuneWheel?: CMSConfigDateRange;
}

export const cmsConfig = (lang: string) =>
  request<CMSConfigApi>({
    url: buildCmsUrl({
      path: 'config',
      lang,
      additionalParams: {
        populate: 'deep',
      },
    }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<CMSConfigApi>
    ),
  });
